const Languages = Object.freeze({
  "zh-cn": {
    name: "Chinese (Mandarin)",
    nativeName: "中文（普通话）",
    nativeScriptName: "中文",
    nativeScriptLang: "zh-Hans",
    dialectLabel: "CN",
    altText: "China Flag",
  },
  "zh-hk": {
    name: "Chinese (Cantonese)",
    nativeName: "中文（粵語）",
    nativeScriptName: "中文",
    nativeScriptLang: "zh-Hant",
    dialectLabel: "HK",
    altText: "China Flag",
  },
  "en-us": {
    name: "English (American)",
    nativeName: "English (US)",
    nativeScriptName: "English",
    nativeScriptLang: "en",
    dialectLabel: "US",
    altText: "America Flag",
  },
  "en-gb": {
    name: "English (British)",
    nativeName: "English (UK)",
    nativeScriptName: "English",
    nativeScriptLang: "en",
    dialectLabel: "UK",
    altText: "Britain Flag",
  },
  "fr-fr": {
    name: "French",
    nativeName: "Français",
    nativeScriptName: "Français",
    nativeScriptLang: "fr",
    dialectLabel: "FR",
    altText: "France Flag",
  },
  "fr-ca": {
    name: "French (Canadian)",
    nativeName: "Français (CA)",
    nativeScriptName: "Français",
    nativeScriptLang: "fr",
    dialectLabel: "CA",
    altText: "Canada Flag",
  },
  de: {
    name: "German",
    nativeName: "Deutsch",
    nativeScriptName: "Deutsch",
    nativeScriptLang: "de",
    dialectLabel: null,
    altText: "Germany Flag",
  },
  ja: {
    name: "Japanese",
    nativeName: "日本語",
    nativeScriptName: "日本語",
    nativeScriptLang: "ja",
    dialectLabel: null,
    altText: "Japan Flag",
  },
  ko: {
    name: "Korean",
    nativeName: "한국어",
    nativeScriptName: "한국어",
    nativeScriptLang: "ko",
    dialectLabel: null,
    altText: "Korea Flag",
  },
  "pt-br": {
    name: "Portuguese (Brazilian)",
    nativeName: "Português (BR)",
    nativeScriptName: "Português",
    nativeScriptLang: "pt",
    dialectLabel: "BR",
    altText: "Brazil Flag",
  },
  "pt-pt": {
    name: "Portuguese (European)",
    nativeName: "Português (PT)",
    nativeScriptName: "Português",
    nativeScriptLang: "pt",
    dialectLabel: "PT",
    altText: "Portugal Flag",
  },
  ru: {
    name: "Russian",
    nativeName: "Русский",
    nativeScriptName: "Русский",
    nativeScriptLang: "ru",
    dialectLabel: null,
    altText: "Russia Flag",
  },
  "es-mx": {
    name: "Spanish (Mexican)",
    nativeName: "Español (MX)",
    nativeScriptName: "Español",
    nativeScriptLang: "es",
    dialectLabel: "MX",
    altText: "Mexico Flag",
  },
  "es-es": {
    name: "Spanish (European)",
    nativeName: "Español (ES)",
    nativeScriptName: "Español",
    nativeScriptLang: "es",
    dialectLabel: "ES",
    altText: "Spain Flag",
  },
  "ta-in": {
    name: "Tamil (Indian)",
    nativeName: "தமிழ்",
    nativeScriptName: "தமிழ்",
    nativeScriptLang: "ta",
    dialectLabel: null,
    altText: "India Flag",
  },
  it: {
    name: "Italian",
    nativeName: "Italiano",
    nativeScriptName: "Italiano",
    nativeScriptLang: "it",
    dialectLabel: null,
    altText: "Italy Flag",
  },
  hi: {
    name: "Hindi",
    nativeName: "हिन्दी",
    nativeScriptName: "हिन्दी",
    nativeScriptLang: "hi",
    dialectLabel: null,
    altText: "India Flag",
  },
  vi: {
    name: "Vietnamese",
    nativeName: "Tiếng Việt",
    nativeScriptName: "Tiếng Việt",
    nativeScriptLang: "vi",
    dialectLabel: null,
    altText: "Vietnam Flag",
  },
  tr: {
    name: "Turkish",
    nativeName: "Türkçe",
    nativeScriptName: "Türkçe",
    nativeScriptLang: "tr",
    dialectLabel: null,
    altText: "Turkey Flag",
  },
  nl: {
    name: "Dutch",
    nativeName: "Nederlands",
    nativeScriptName: "Nederlands",
    nativeScriptLang: "nl",
    dialectLabel: null,
    altText: "Netherlands Flag",
  },
  pl: {
    name: "Polish",
    nativeName: "Polski",
    nativeScriptName: "Polski",
    nativeScriptLang: "pl",
    dialectLabel: null,
    altText: "Poland Flag",
  },
  id: {
    name: "Indonesian",
    nativeName: "Bahasa Indonesia",
    nativeScriptName: "Bahasa Indonesia",
    nativeScriptLang: "id",
    dialectLabel: null,
    altText: "Indonesia Flag",
  },
  uk: {
    name: "Ukrainian",
    nativeName: "Українська",
    nativeScriptName: "Українська",
    nativeScriptLang: "uk",
    dialectLabel: null,
    altText: "Ukraine Flag",
  },
  el: {
    name: "Greek",
    nativeName: "Ελληνικά",
    nativeScriptName: "Ελληνικά",
    nativeScriptLang: "el",
    dialectLabel: null,
    altText: "Greece Flag",
  },
  sv: {
    name: "Swedish",
    nativeName: "Svenska",
    nativeScriptName: "Svenska",
    nativeScriptLang: "sv",
    dialectLabel: null,
    altText: "Sweden Flag",
  },
  no: {
    name: "Norwegian",
    nativeName: "Norsk",
    nativeScriptName: "Norsk",
    nativeScriptLang: "no",
    dialectLabel: null,
    altText: "Norway Flag",
  },
  da: {
    name: "Danish",
    nativeName: "Dansk",
    nativeScriptName: "Dansk",
    nativeScriptLang: "da",
    dialectLabel: null,
    altText: "Denmark Flag",
  },
  fi: {
    name: "Finnish",
    nativeName: "Suomi",
    nativeScriptName: "Suomi",
    nativeScriptLang: "fi",
    dialectLabel: null,
    altText: "Finland Flag",
  },
  "bn-in": {
    name: "Bengali (Indian)",
    nativeName: "বাংলা",
    nativeScriptName: "বাংলা",
    nativeScriptLang: "bn",
    dialectLabel: null,
    altText: "India Flag",
  },
  te: {
    name: "Telugu",
    nativeName: "తెలుగు",
    nativeScriptName: "తెలుగు",
    nativeScriptLang: "te",
    dialectLabel: null,
    altText: "India Flag",
  },
  mr: {
    name: "Marathi",
    nativeName: "मराठी",
    nativeScriptName: "मराठी",
    nativeScriptLang: "mr",
    dialectLabel: null,
    altText: "India Flag",
  },
});

// Sort all languages alphabetically by name
const sortedLanguages = Object.fromEntries(
  Object.entries(Languages).sort((a, b) => a[1].name.localeCompare(b[1].name))
);

/**
 * How a language is named to the learner: in its own script, since that is
 * what every switcher surface already shows. Falls back to the raw code so a
 * language the server knows about before this bundle ships still renders.
 * @param {string|null|undefined} code
 * @returns {string}
 */
export const languageName = (code) => Languages[code]?.nativeName || code || "";

export { sortedLanguages as default, Languages };
